import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import CurrencyInput from 'react-currency-input-field';
import { th } from 'style/theme';
import { FaCheck } from 'react-icons/fa';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledCurrencyInput = styled(CurrencyInput)`
  width: 100%;
  margin-top: 0;
  padding-top: 6px;
  padding-left: 0;
  border-radius: 0;
  font-size: 16px;
  background-color: transparent;
  color: ${th('colors.black')};
  ${(p) =>
    p.disabled === false &&
    css`
      border-bottom: 1px solid ${th('colors.black')};
    `}

  ::placeholder {
    color: ${th('colors.black')};
    opacity: 0.5;
    font-style: italic;
  }
`;

export const ErrorMessage = styled.span`
  color: ${th('colors.red')};
  font-weight: 700;
  font-size: 14px;
`;

export const CheckIcon = styled(FaCheck)`
  font-size: 14px;
  color: ${th('colors.bermudaGreen')};
`;

const MoneyInput = ({ name, onChange, value, placeholder, disabled = false }) => {
  return (
    <Container>
      <StyledCurrencyInput
        name={name}
        decimalsLimit={2}
        decimalScale={2}
        decimalSeparator="."
        groupSeparator=","
        onValueChange={onChange}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
      />
    </Container>
  );
};

MoneyInput.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeholder: PropTypes.string
};

export default MoneyInput;
